import React from 'react';

const TableResponsive: React.FC<{
  className?: string;
}> = (props) => {
  return <div className={`table-responsive ${props.className || ''}`}>{props.children}</div>;
};

export default TableResponsive;
